<template>
    <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="$rules.Adddepartment">
                <div class="Tips" v-if="type == 'add'">* 请注意，所属区一旦添加将不可修改，请谨慎添加!!!</div>
            <el-row >
                <el-col :span="type == 'add' ? 11 : 22" v-if="type == 'add'">
                     <el-form-item label="所属区：" prop="districtId">
                        <el-select clearable v-model="form.districtId" placeholder="请输入所属区">
                            <el-option  v-for="(item,index) in $Region.list()" :key="index"  :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="type == 'add' ? 11 : 22">
                     <el-form-item label="部门名称：" prop="name">
                        <el-input  v-model="form.name" placeholder="请输入部门名称"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="buttons">
                    <el-button @click="$emit('update:visibles',false)">取消</el-button>
                    <el-button type="primary" @click="submit()">{{type === 'add' ? '添加' : '修改'}}</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    type: {
      type: String
    },
    row: {
      type: Object
    }
  },
  data () {
    return {
      form: {
        deptId: ''
      },
      loading: false,
      departmentList: [],
      deptIds: null
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 提交
    submit () {
      var that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          var Submitform = {}
          if (that.type === 'add') {
            Submitform = this.form
            Submitform.parentId = 0
          } else if (this.type === 'edit') {
            Submitform = {
              id: that.form.id,
              name: that.form.name,
              districtId: that.form.districtId,
              parentId: 0
            }
          } else if (this.type === 'AddChildren') {
            Submitform = {
              parentId: that.row.id,
              name: that.form.name,
              districtId: that.row.districtId
            }
          }
          var RequestType = that.type === 'add' || that.type === 'AddChildren' ? 'post' : 'put'
          var RequestTypeText = that.type === 'add' || that.type === 'AddChildren' ? '添加' : '修改'
          var RequestUrl = that.type === 'add' || that.type === 'AddChildren' ? '"/dict/department/save"' : '"/dict/department/updateDept"'
          // eslint-disable-next-line
          eval(
                `that.$http.${RequestType}(${RequestUrl},${JSON.stringify(Submitform)}).then((res) => { 
                    if(res.status == 200){ 
                        that.$message.success('${RequestTypeText}成功')
                        that.$emit('update:visibles',false) 
                        that.$emit('Render') 
                        sessionStorage.removeItem('dict.department.list')
                    } else {
                        that.$message.error('${RequestTypeText}失败') 
                        that.$emit('update:visibles',true)
                    }
                })`
          )
        }
      })
    },
    // js暂停的方法
    sleep (interval) {
      return new Promise(resolve => {
        this.loading = true
        setTimeout(resolve, interval)
      })
    },
    async Layoutfun (query = '', data, Parameter1) {
      if (query !== '') {
        await this.sleep(150)
        this.loading = false
        // eslint-disable-next-line no-eval
        return data.filter(item => { return eval('item.' + Parameter1).toLowerCase().indexOf(query.toLowerCase()) > -1 })
      } else {
        return data.slice(0, 10)
      }
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.Layoutfun(query, this.$department.list(), 'name').then(res => {
        this.departmentList = res
        this.addValueOptions()
      })
    },
    // 修改回显问题
    addValueOptions () {
      if (this.deptIds) {
        const target = this.$department.list().find((item) => { // 从大option中找到当前条
          return item.id === this.deptIds
        })
        if (target) { // 将当前条与小option比对，没有则加入
          if (this.departmentList.every(item => item.id !== target.id)) {
            this.departmentList.unshift(target)
          }
        }
      }
    }
  },
  created () {
    if (this.type === 'edit') {
      this.form = JSON.parse(JSON.stringify(this.row))
      this.deptIds = this.form.deptId
    }
    this.departmentRemoteMethod()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.buttons{
    text-align: center;
}
.Tips{
    color: red;
    letter-spacing: 2px;
    font-size: 14px;
    margin-bottom: 20px;
}
</style>
